import React from "react";
import AddUpdateStore from "../Add-Update";
import "../Add-Update/addstore.css"

const AddStore = () => {


  return (
    <div className="main-container">
      <AddUpdateStore name={"Add Store"} />
    </div>
  );
};

export default AddStore;
